const icon = (
    <svg
        version="1.1"
        id="coupon-creator-icon"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 24 24"
        width="24px"
        height="24px"
    >
      <g fill="black">
          <g>
              <g >
                  <polygon points="21,21 17,21 17,19 19,19 19,17 21,17 			"/>
                  <rect x="9.3" y="19" width="5.3" height="2"/>
                  <polygon points="7,21 3,21 3,17 5,17 5,19 7,19 			"/>
                  <rect x="3" y="9.3" width="2" height="5.3"/>
                  <polygon points="5,7 3,7 3,3 7,3 7,5 5,5 			"/>
                  <rect x="9.3" y="3" width="5.3" height="2"/>
                  <polygon points="21,7 19,7 19,5 17,5 17,3 21,3 			"/>
                  <rect x="19" y="9.3" width="2" height="5.3"/>
              </g>
          </g>
          <g>
              <path fill="black" d="M10.1,15.6c-0.4-0.5-0.6-1.2-0.6-2.1v-3c0-0.9,0.2-1.6,0.6-2.1c0.4-0.5,1-0.7,1.9-0.7c0.9,0,1.5,0.2,1.9,0.6
                  c0.4,0.4,0.5,1,0.5,1.8v0.7h-1.8V10c0-0.3,0-0.6-0.1-0.7C12.5,9.1,12.3,9,12.1,9c-0.3,0-0.4,0.1-0.5,0.3c-0.1,0.2-0.1,0.4-0.1,0.8
                  V14c0,0.3,0,0.6,0.1,0.8c0.1,0.2,0.3,0.3,0.5,0.3c0.3,0,0.4-0.1,0.5-0.3c0.1-0.2,0.1-0.4,0.1-0.8v-0.9h1.8v0.7
                  c0,0.8-0.2,1.4-0.5,1.8c-0.4,0.4-1,0.7-1.9,0.7C11.1,16.3,10.5,16.1,10.1,15.6z"/>
          </g>
      </g>
    </svg>
);

export default icon;



// WEBPACK FOOTER //
// ./src/modules/blocks/coupon/icon.js